import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import * as moment from 'moment'
import 'moment-timezone';
import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({

    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    public project_id: any = {};
    public session_data: any = {};
    public err: any = {};
    public result: any = {};
    public latest_mentions = [];
    public popular_mentions = [];
    public top_profile_mentions = [];
    public top_site_mentions = [];
    public form: any = {};
    public summary: any = {};
    public sentiment = 0;

    public popularLoading = false;
    public mmapLoading = false;
    public smmapLoading = false;
    public summaryLoading = false;
    public profilesLoading = false;
    public total_per_sm: any = {};

    public blocked_items: any = {};

    header_data: any = { heading: "Dashboard" };

    public lineChartData = [];
    public smLineChartData = [];
    public lineChartLabels = [];
    public lineChartLegend = false;
    public lineChartType = 'line';
    public lineChartPlugins = [];
    public lineChartColors: Color[] = [{ borderColor: '#0FB36C' }];
    public lineChartOptions: (ChartOptions & { annotation: any }) = {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
            yAxes: [
                {
                    ticks: {
                        maxTicksLimit: 5
                    }
                }
            ],
            xAxes: [
                {
                    type: 'time',
                    distribution: 'series',
                    time: {
                        tooltipFormat: 'DD MMM',
                        displayFormats: {
                            'millisecond': '',
                            'second': 'DD MMM',
                            'minute': 'DD MMM',
                            'hour': 'DD MMM',
                            'day': 'DD MMM',
                            'week': 'DD MMM',
                            'month': 'DD MMM',
                            'quarter': 'DD MMM',
                            'year': 'DD MMM',
                        }
                    }
                },
            ]
        },
        annotation: {},
    };

    public selected: any = {};
    alwaysShowCalendars: boolean;
    showRangeLabelOnInput: boolean;
    keepCalendarOpeningWithRange: boolean;
    ranges: any = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 3 Month': [moment().subtract(3, 'month'), moment()]
    };

    constructor(private router: Router, public fb: FormBuilder, private service: DashboardService, private login: LoginService, private route: ActivatedRoute) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.service.setTitle('Dashboard | 24ieye');

        this.form = this.fb.group({
            user_id: [''],
        });
        this.alwaysShowCalendars = true;
        this.keepCalendarOpeningWithRange = true;
        this.project_id = this.route.snapshot.queryParams["id"];
        this.selected = { startDate: login.get_session_data('ieye_session_start_date'), endDate: login.get_session_data('ieye_session_end_date') };
    }
    ngOnInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.initialRequests();
        });
    }

    public initialRequests() {
        this.get_summary(this.selected.startDate, this.selected.endDate);
        this.get_latest_mentions(this.selected.startDate, this.selected.endDate);
        this.get_popular_mentions(this.selected.startDate, this.selected.endDate);
        this.get_topprofile_mentions(this.selected.startDate, this.selected.endDate);
        this.get_topsites_mentions(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_sm_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
    }

    datesUpdated(range) {
        if (range.startDate != null && range.endDate != null) {
            this.service.saveDateRange(moment(range.startDate._d).format("YYYY-MM-DD"), moment(range.endDate._d).format("YYYY-MM-DD"));
            this.selected = { startDate: this.login.get_session_data('ieye_session_start_date'), endDate: this.login.get_session_data('ieye_session_end_date') };
            this.get_summary(this.selected.startDate, this.selected.endDate);
            this.get_latest_mentions(this.selected.startDate, this.selected.endDate);
            this.get_popular_mentions(this.selected.startDate, this.selected.endDate);
            this.get_topprofile_mentions(this.selected.startDate, this.selected.endDate);
            this.get_topsites_mentions(this.selected.startDate, this.selected.endDate);
            this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
            this.get_sm_mentions_graph(this.selected.startDate, this.selected.endDate);
            this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        }
    }

    public async get_sm_mentions_graph(start, end) {
        this.smmapLoading = true;
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'sm_mentions_map');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 5);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
            this.smmapLoading = false;
        } else {
            this.smLineChartData = [
                {
                    data: this.result.data,
                    label: '', borderWidth: 2, pointRadius: 0, lineTension: 0, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: true
                }
            ];
            this.smmapLoading = false;
        }
    }

    public async get_mentions_graph(start, end) {
        this.mmapLoading = true;
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'mentions_map');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 5);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
            this.mmapLoading = false;
        } else {
            this.lineChartData = [
                {
                    data: this.result.data,
                    label: '', borderWidth: 2, pointRadius: 0, lineTension: 0, backgroundColor: 'rgba(0, 0, 0, 0)', stacked: true
                }
            ];
            this.mmapLoading = false;
        }
    }

    public async get_latest_mentions(start, end) {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'latest');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 5);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.latest_mentions = this.result.data.mentions;

            this.blocked_items.mentions = this.result.user.blocked_mentions;
            this.blocked_items.profiles = this.result.user.blocked_profiles;
        }
    }

    public async get_popular_mentions(start, end) {
        this.popularLoading = true;
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'popular');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 5);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.popularLoading = false;
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.popularLoading = false;
            this.popular_mentions = this.result.data.mentions;

            this.blocked_items.mentions = this.result.user.blocked_mentions;
            this.blocked_items.profiles = this.result.user.blocked_profiles;
        }
    }

    public async get_topprofile_mentions(start, end) {
        this.profilesLoading = true;
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'all');
        formData.append("sort", 'engagement');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 20);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        formData.append("sentiment", 'all');
        formData.append("channels[twitter]", true);
        formData.append("channels[facebook]", true);
        formData.append("channels[instagram]", false);
        formData.append("channels[web]", false);
        formData.append("channels[youtube]", true);
        formData.append("channels[reviews]", false);
        formData.append("channels[others]", false);
        formData.append("channels[all]", false);
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.profilesLoading = false;
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.profilesLoading = false;
            this.top_profile_mentions = this.get_unique_data(this.result.data.mentions, 5);
        }
    }

    public async get_topsites_mentions(start, end) {
        this.profilesLoading = true;
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'all');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 5);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        formData.append("sentiment", "all");
        formData.append("sort", 'rank');
        formData.append("channels[twitter]", true);
        formData.append("channels[facebook]", true);
        formData.append("channels[instagram]", true);
        formData.append("channels[web]", true);
        formData.append("channels[youtube]", true);
        formData.append("channels[reviews]", true);
        formData.append("channels[others]", true);
        formData.append("channels[all]", false);
        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.profilesLoading = false;
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.profilesLoading = false;
            this.top_site_mentions = this.result.data.mentions;
        }
    }

    public update_datepicker_latest() {
        this.selected = { startDate: moment().subtract(29, 'days'), endDate: moment() };
        this.get_latest_mentions(this.selected.startDate, this.selected.endDate);
        this.get_popular_mentions(this.selected.startDate, this.selected.endDate);
        this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_sm_mentions_graph(this.selected.startDate, this.selected.endDate);
    }

    public async get_summary(start, end) {
        this.summary.all = this.summary.interactions = this.summary.positive = this.summary.negative = this.summary.sm = '<img src="assets/images/small-loader.gif">';
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'summary');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 5);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.summary.all = this.result.data.all;
            this.summary.interactions = this.result.data.interactions;
            this.summary.positive = this.result.data.positive;
            this.summary.negative = this.result.data.negative;
            this.summary.sm = this.result.data.sm;
        }
    }

    public change_date_format(date, format) {
        return moment.tz(date, 'Asia/Muscat').utc().format(format);
    }

    public get_social_icon(channel) {
        switch (channel) {
            case 'web': {
                return 'assets/images/icons/share-2.svg';
                break;
            }
            case 'facebook': {
                return 'assets/images/icons/facebook.svg';
                break;
            }
            case 'instagram': {
                return 'assets/images/icons/instagram.svg';
                break;
            }
            case 'twitter': {
                return 'assets/images/icons/twitter.svg';
                break;
            }
            case 'youtube': {
                return 'assets/images/icons/youtube.svg';
                break;
            }
            case 'linkedin': {
                return 'assets/images/icons/linkedin.svg';
                break;
            }
            default: {
                return 'assets/images/icons/share-2.svg';
                break;
            }
        }
    }

    public get_unique_data(data, length) {
        var going = true;
        var res = [];
        var saved = [];
        data.forEach((val, index) => {
            if (going) {
                if (saved.indexOf(val.uid) == -1) {
                    saved.push(val.uid);
                    res.push(val);
                }
                if (res.length === length) {
                    going = false;
                    return res;
                }
            }
        });
        return res;
    }

    public async get_mentions_per_sm(start, end) {
        this.total_per_sm.all = this.total_per_sm.twitter = this.total_per_sm.facebook = this.total_per_sm.instagram = this.total_per_sm.web = this.total_per_sm.youtube = this.total_per_sm.reviews = this.total_per_sm.others = this.total_per_sm.linkedin = this.total_per_sm.reddit = '<img src="assets/images/small-loader.gif">';
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'count_per_sm');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 10);
        formData.append("sentiment", this.sentiment);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.total_per_sm.all = this.result.data.all;
            this.total_per_sm.web = this.result.data.web;
            this.total_per_sm.twitter = this.result.data.twitter;
            this.total_per_sm.facebook = this.result.data.facebook;
            this.total_per_sm.instagram = this.result.data.instagram;
            this.total_per_sm.youtube = this.result.data.youtube;
            this.total_per_sm.reviews = this.result.data.reviews;
            this.total_per_sm.others = this.result.data.others;
            this.total_per_sm.linkedin = this.result.data.linkedin;
            this.total_per_sm.reddit = this.result.data.reddit;
        }
    }

    public can_show_mention(id, profile_id) {
        var mentions = JSON.stringify(this.blocked_items.mentions);
        var profiles = JSON.stringify(this.blocked_items.profiles);
        if (mentions.indexOf(id) !== -1 || profiles.indexOf(profile_id) !== -1) {
            return 'none';
        }
        return 'block';
    }

}
